/**
 * The command will be: editor.execute( 'myCommandName', { ID } );
 * 'myCommandName' is passed in as an option = IPluginOptions['options']['nameCommand']
 * ID is a string identifier so CKEditor knows where the unique element is in the model and DOM
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Plugin } from '@ckeditor/ckeditor5-core';
import { Widget, toWidget } from '@ckeditor/ckeditor5-widget';
import { TheCommand } from './command';
import { SharedState } from './common';
export const createPlugin = ({ namePropertyOptions, }) => {
    var _PluginGenericWidget_instances, _PluginGenericWidget_stateShared, _PluginGenericWidget_pluginOptions, _PluginGenericWidget_defineSchema, _PluginGenericWidget_defineConverters, _PluginGenericWidget_getPluginOptions, _PluginGenericWidget_setupEvents;
    const pluginCustomdefaults = {
        namePropertyOptions: namePropertyOptions,
    };
    const nameClass = 'PluginGenericWidget';
    class PluginGenericWidget extends Plugin {
        constructor() {
            super(...arguments);
            _PluginGenericWidget_instances.add(this);
            _PluginGenericWidget_stateShared.set(this, new SharedState());
            _PluginGenericWidget_pluginOptions.set(this, void 0);
            _PluginGenericWidget_getPluginOptions.set(this, () => this.editor.config.get(pluginCustomdefaults.namePropertyOptions));
            _PluginGenericWidget_setupEvents.set(this, ({ elementTypes, pluginOptions, }) => {
                this.listenTo(this.editor.editing.view.document, 'delete', (evt, data) => {
                    var _a;
                    const elementsWidgets = ((_a = data.domTarget) === null || _a === void 0 ? void 0 : _a.querySelectorAll(elementTypes.root)) || [];
                    const widgets = Array.from(elementsWidgets).reduce((acc, el) => {
                        const IDWidget = el.getAttribute('data-widget-name');
                        if (IDWidget === pluginOptions.options.nameWidget) {
                            const ID = el.getAttribute('data-id');
                            const data = __classPrivateFieldGet(this, _PluginGenericWidget_stateShared, "f").state.get(ID);
                            acc.map.set(ID, {
                                data,
                                element: el,
                            });
                            acc.list.push(ID);
                        }
                        return acc;
                    }, {
                        list: [],
                        map: new Map(),
                    });
                    setTimeout(() => {
                        widgets.list.forEach((ID) => {
                            var _a, _b, _c;
                            const existInEditor = (_a = data.domTarget) === null || _a === void 0 ? void 0 : _a.querySelector(`[data-id=${ID}]`);
                            if (!existInEditor) {
                                const { data, element } = widgets.map.get(ID);
                                const payload = {
                                    elementComponentWrapper: element.firstChild,
                                    elementWidget: element,
                                    elementWidgetID: ID,
                                    data,
                                };
                                (_b = data.onDelete) === null || _b === void 0 ? void 0 : _b.call(data, payload);
                                (_c = pluginOptions === null || pluginOptions === void 0 ? void 0 : pluginOptions.onDelete) === null || _c === void 0 ? void 0 : _c.call(pluginOptions, payload);
                            }
                        });
                        widgets.map.clear();
                        widgets.list.length = 0;
                    }, 0);
                }, { context: '$root' });
                this.editor.model.document.on('change:data', (evt) => {
                    var _a, _b, _c, _d;
                    if (evt.source.differ.isEmpty) {
                        return;
                    }
                    for (const { attributes, name, type, } of this.editor.model.document.differ.getChanges({
                        includeChangesInGraveyard: true,
                    })) {
                        if (name === pluginOptions.options.nameWidget) {
                            const ID = attributes.get('id');
                            const data = __classPrivateFieldGet(this, _PluginGenericWidget_stateShared, "f").state.get(ID);
                            if (!data) {
                                continue;
                            }
                            switch (type) {
                                case 'insert':
                                    (_a = data.onInsert) === null || _a === void 0 ? void 0 : _a.call(data, data);
                                    (_b = pluginOptions === null || pluginOptions === void 0 ? void 0 : pluginOptions.onInsert) === null || _b === void 0 ? void 0 : _b.call(pluginOptions, data);
                                    break;
                                case 'remove':
                                    // allows user to prime data in the store
                                    // this occurs because when CKEditor initializes, it does remove as an initial action when finding matches
                                    if (!data.hasRendered) {
                                        break;
                                    }
                                    (_c = data.onRemove) === null || _c === void 0 ? void 0 : _c.call(data, data);
                                    (_d = pluginOptions === null || pluginOptions === void 0 ? void 0 : pluginOptions.onRemove) === null || _d === void 0 ? void 0 : _d.call(pluginOptions, data);
                                    __classPrivateFieldGet(this, _PluginGenericWidget_stateShared, "f").state.delete(ID);
                                    break;
                                default:
                            }
                        }
                    }
                });
            });
        }
        static get requires() {
            return [Widget];
        }
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        init() {
            const pluginOptionsBase = __classPrivateFieldGet(this, _PluginGenericWidget_getPluginOptions, "f").call(this);
            const stateLocal = {
                canInitialize: true,
            };
            if (!(pluginOptionsBase === null || pluginOptionsBase === void 0 ? void 0 : pluginOptionsBase.render)) {
                stateLocal.canInitialize = false;
            }
            if (!(pluginOptionsBase === null || pluginOptionsBase === void 0 ? void 0 : pluginOptionsBase.options.nameWidget) ||
                !(pluginOptionsBase === null || pluginOptionsBase === void 0 ? void 0 : pluginOptionsBase.options.nameCommand)) {
                stateLocal.canInitialize = false;
            }
            if (!stateLocal.canInitialize) {
                return;
            }
            const pluginOptions = pluginOptionsBase;
            __classPrivateFieldSet(this, _PluginGenericWidget_pluginOptions, pluginOptions, "f");
            const elementTypes = Object.assign({ root: 'section', wrapperComponent: 'div' }, pluginOptions.options.elementTypes);
            __classPrivateFieldGet(this, _PluginGenericWidget_instances, "m", _PluginGenericWidget_defineSchema).call(this, { pluginOptions });
            __classPrivateFieldGet(this, _PluginGenericWidget_setupEvents, "f").call(this, { elementTypes, pluginOptions });
            __classPrivateFieldGet(this, _PluginGenericWidget_instances, "m", _PluginGenericWidget_defineConverters).call(this, { elementTypes, pluginOptions });
            // lagging behind CKEditor versions, this assertion can be removed when updating
            // @ts-ignore
            const command = new TheCommand(this.editor);
            command.setState({ pluginOptions, stateShared: __classPrivateFieldGet(this, _PluginGenericWidget_stateShared, "f") });
            this.editor.commands.add(pluginOptions.options.nameCommand, command);
        }
        destroy() {
            var _a, _b, _c;
            for (let [ID, data] of __classPrivateFieldGet(this, _PluginGenericWidget_stateShared, "f").state) {
                const payload = {
                    elementComponentWrapper: data.elementParent,
                    elementWidget: data.elementParent.firstChild,
                    elementWidgetID: ID,
                    data,
                };
                (_a = data.onDelete) === null || _a === void 0 ? void 0 : _a.call(data, payload);
                (_c = (_b = __classPrivateFieldGet(this, _PluginGenericWidget_pluginOptions, "f")).onDelete) === null || _c === void 0 ? void 0 : _c.call(_b, payload);
            }
            __classPrivateFieldGet(this, _PluginGenericWidget_stateShared, "f").destroy();
            super.destroy();
        }
    }
    _PluginGenericWidget_stateShared = new WeakMap(), _PluginGenericWidget_pluginOptions = new WeakMap(), _PluginGenericWidget_getPluginOptions = new WeakMap(), _PluginGenericWidget_setupEvents = new WeakMap(), _PluginGenericWidget_instances = new WeakSet(), _PluginGenericWidget_defineSchema = function _PluginGenericWidget_defineSchema({ pluginOptions, }) {
        this.editor.model.schema.register(pluginOptions.options.nameWidget, Object.assign({ 
            // Behaves like a self-contained object (e.g. an image).
            isObject: true, 
            // Allow in places where other blocks are allowed (e.g. directly in the root).
            allowWhere: '$block', allowAttributes: ['id', 'widget-name'] }, pluginOptions.options.schema));
    }, _PluginGenericWidget_defineConverters = function _PluginGenericWidget_defineConverters({ elementTypes, pluginOptions, }) {
        const classes = Object.assign({ root: nameClass, wrapperComponent: nameClass + '__ComponentWrapper' }, pluginOptions.options.classes);
        // <TheWidget> converters ((data) view → model)
        this.editor.conversion.for('upcast').elementToElement({
            view: {
                name: elementTypes.root,
                classes: classes.root,
            },
            model: (viewElement, { writer: modelWriter }) => {
                // Read the "data-id" attribute from the view and set it as the "id" in the model.
                return modelWriter.createElement(pluginOptions.options.nameWidget, {
                    id: viewElement.getAttribute('data-id'),
                    'widget-name': viewElement.getAttribute('data-widget-name'),
                });
            },
        });
        // <TheWidget> converters (model → data view)
        this.editor.conversion.for('dataDowncast').elementToElement({
            model: pluginOptions.options.nameWidget,
            view: (modelElement, { writer: viewWriter }) => {
                // In the data view, the model <TheWidget> corresponds to:
                //
                // <elementTypes.root class="..." data-id="..."></elementTypes.root>
                return viewWriter.createEmptyElement(elementTypes.root, {
                    class: classes.root,
                    'data-id': modelElement.getAttribute('id'),
                    'data-widget-name': modelElement.getAttribute('widget-name'),
                });
            },
        });
        // <TheWidget> converters (model → editing view)
        this.editor.conversion.for('editingDowncast').elementToElement({
            model: pluginOptions.options.nameWidget,
            view: (modelElement, { writer: viewWriter }) => {
                // In the editing view, the model <TheWidget> corresponds to:
                //
                // <elementTypes.root class="..." data-id="...">
                //     <elementTypes.wrapperComponent class="...">
                //         <TheWidget /> (component)
                //     </elementTypes.wrapperComponent>
                // </elementTypes.root>
                const id = modelElement.getAttribute('id');
                // The outermost <elementTypes.root class="..." data-id="..."></elementTypes.root> element.
                const elementRoot = viewWriter.createContainerElement(elementTypes.root, {
                    class: classes.root,
                    'data-id': id,
                    'data-widget-name': modelElement.getAttribute('widget-name'),
                });
                // The inner <elementTypes.wrapperComponent class="..."></elementTypes.wrapperComponent> element.
                // This element will host a <TheWidget /> component.
                const elementComponentWrapper = viewWriter.createRawElement(elementTypes.wrapperComponent, {
                    class: classes.wrapperComponent,
                }, (elementParent) => __awaiter(this, void 0, void 0, function* () {
                    try {
                        const dataBase = __classPrivateFieldGet(this, _PluginGenericWidget_stateShared, "f").state.get(id);
                        const data = Object.assign(Object.assign({}, dataBase), { elementParent, editor: this.editor });
                        // This the place where component renders the actual component hosted
                        // by a UIElement in the view.
                        yield pluginOptions.render(data);
                        if (!data.hasRendered) {
                            data.hasRendered = true;
                        }
                        __classPrivateFieldGet(this, _PluginGenericWidget_stateShared, "f").state.set(id, data);
                    }
                    catch (_a) { }
                }));
                viewWriter.insert(viewWriter.createPositionAt(elementRoot, 0), elementComponentWrapper);
                return toWidget(elementRoot, viewWriter, {
                    label: pluginOptions.options.label || 'default-widget',
                });
            },
        });
    };
    PluginGenericWidget.pluginCustomdefaults = pluginCustomdefaults;
    return PluginGenericWidget;
};
